import { supabase } from './supabase';
import { capturePostHogEvent } from './posthog';

const API_URL = ((import.meta.env.PUBLIC_API_BASE_URL as string | undefined) ?? '/api').replace(
  /\/+$/,
  '',
) || '/api';

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const { data: { session } } = await supabase.auth.getSession();

  const headers = new Headers(init?.headers);
  if (session?.access_token) {
    headers.set('Authorization', `Bearer ${session.access_token}`);
  }
  headers.set('Content-Type', 'application/json');

  const method = (init?.method ?? 'GET').toUpperCase();

  let response: Response;
  try {
    response = await fetch(`${API_URL}${path}`, {
      ...init,
      headers,
    });
  } catch (err) {
    // Network failure (DNS, offline, CORS, etc.) — surface as a structured
    // event so we can distinguish from server-side 5xx. We deliberately do
    // not include any request payload (SIG-63 sensitive-data rules).
    capturePostHogEvent('frontend_api_error', {
      endpoint: path,
      method,
      status_code: 0,
      error_kind: 'network_error',
      error_message: err instanceof Error ? err.message : String(err),
      route: typeof window !== 'undefined' ? window.location.pathname : undefined,
    });
    throw err;
  }

  if (!response.ok) {
    capturePostHogEvent('frontend_api_error', {
      endpoint: path,
      method,
      status_code: response.status,
      route: typeof window !== 'undefined' ? window.location.pathname : undefined,
    });
  }

  return response;
}
